import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Client as Styletron } from "styletron-engine-atomic";
import { Provider as StyletronProvider } from "styletron-react";
import { BaseProvider } from "baseui";
import { ClerkProvider } from "@clerk/react";
import { theme } from "./theme";
import Routes from "./routes";
import * as serviceWorker from "./serviceWorker";
import "./theme/global.css";

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Publishable Key");
}

const App = () => {
  const engine = new Styletron();
  useEffect(() => {
    // Only remove on manual logout now, as Clerk handles persistent sessions
    // localStorage.removeItem("ldapToken");
  }, []);

  return (
    <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
      <StyletronProvider value={engine}>
        <BaseProvider theme={theme}>
          <BrowserRouter>
            <Routes />
          </BrowserRouter>
        </BaseProvider>
      </StyletronProvider>
    </ClerkProvider>
  );
};

const root = createRoot(document.getElementById("root")!);
root.render(<App />);

serviceWorker.unregister();
